/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingValidationState
 */
export interface RecordingValidationState {
    /**
     * 
     * @type {string}
     * @memberof RecordingValidationState
     */
    status?: RecordingValidationStateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RecordingValidationState
     */
    id?: string | null;
}


/**
 * @export
 */
export const RecordingValidationStateStatusEnum = {
    Validated: 'validated',
    Pending: 'pending',
    Review: 'review',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;
export type RecordingValidationStateStatusEnum = typeof RecordingValidationStateStatusEnum[keyof typeof RecordingValidationStateStatusEnum];


/**
 * Check if a given object implements the RecordingValidationState interface.
 */
export function instanceOfRecordingValidationState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RecordingValidationStateFromJSON(json: any): RecordingValidationState {
    return RecordingValidationStateFromJSONTyped(json, false);
}

export function RecordingValidationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingValidationState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function RecordingValidationStateToJSON(value?: RecordingValidationState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'id': value.id,
    };
}

